export enum TypeUO {
  AD= 'Association départementale',
  ANT= 'Antenne',
  AN= 'Service'
}
